import
{
  ADD_ERROR,
  CLEAR_ERROR,
  RECEIVE_SETTINGS,
  RECEIVE_USER,
} from './actions/Settings';

export const TOGGLE_SCROLLER = 'SETTINGS.TOGGLE_SCROLLER';


const initialState = {
  scrollerOpen: true,
};

const FindingsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TOGGLE_SCROLLER: {
      return {
        ...state,
        scrollerOpen: !state.scrollerOpen,
      };
    }

    case ADD_ERROR: {
      return {
        ...state,
        error: action.error,
      };
    }

    case CLEAR_ERROR: {
      const { error, ...newState } = state;

      return newState;
    }

    case RECEIVE_SETTINGS: {
      return {
        ...state,
        ...action.settings,
      };
    }

    case RECEIVE_USER: {
      return {
        ...state,
        user: action.user,
      };
    }

    default:
      return state;
  }
};

export default FindingsReducer;



// WEBPACK FOOTER //
// ./src/redux/SettingsReducer.js